import React, {Component} from 'react';
import ListItemsComponent from "./ListItemsComponent";
import {GeneralContent, Status} from '../Redux/ContentfulContentGrabber';
import {connect} from "react-redux";
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

class SystemStatusListComponent extends Component {

    //Fetches data from Contentful Before The Component Mounts
    componentWillMount() {
        this.props.fetchData();
        this.props.fetchStatusData();
    }

    //Checks to see if contentful content has returned data yet
    isContentfulContentAvailableYet() {
        return !Array.isArray(this.props.systems) && !Array.isArray(this.props.status) && !Array.isArray(this.props.generalContent);
    }

    render() {
        let tableTitle;
        let status = [];

        if (this.isContentfulContentAvailableYet()) {
            tableTitle = this.props.generalContent.items[0].fields.websiteSubtitle;

            for (let i = 0; i < this.props.status.items.length; i++) {
                let statusName = this.props.status.items[i].fields.statusName;
                status.push(
                    <div className="tableHeaderIcons">
                        <img draggable="false"
                             src={this.props.status.items[i].fields.statusIcon.fields.file.url} width="20"
                             alt="Status"/>
                        <span className="fontRegularSmall" style={{marginRight: "5px"}}> {statusName}</span>
                    </div>
                );
            }
        }

        return (
            <ReactCSSTransitionGroup
                transitionName="example"
                transitionAppear={true}
                transitionAppearTimeout={50000}
                transitionEnter={false}
                transitionLeave={false}>
                <div className="card">
                    <div className="card-header">
                        <p className={"tableTitle"}>{tableTitle}</p>
                        <div className={"statusIcons"}>
                            {status}
                        </div>
                    </div>
                    <div>
                        <ListItemsComponent/>
                    </div>
                </div>
            </ReactCSSTransitionGroup>
        );
    }
}

//Redux, gathers all Contentful Data
const mapStateToProps = (state) => {
    return {
        generalContent: state.generalContent,
        status: state.status,
        hasErrored: state.itemsHasErrored,
        isLoading: state.itemsIsLoading
    };
};

//Redux, gathers all Contentful Data
const mapDispatchToProps = (dispatch) => {
    return {
        fetchData: () => dispatch(GeneralContent()),
        fetchStatusData: () => dispatch(Status())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SystemStatusListComponent);



// WEBPACK FOOTER //
// ./src/Components/SystemStatusListComponent.js